import { fetchResource } from "../helpers/network";

import {
  setErrorNotification,
  setSuccessNotification
} from "../actions/notifications";

export const REQUEST_USERS = "REQUEST_USERS";
export const RECEIVE_USERS = "RECEIVE_USERS";

export const EDIT_USER = "EDIT_USER";
export const CANCEL_EDIT_USER = "CANCEL_EDIT_USER";
export const PATCH_EDIT_USER = "PATCH_EDIT_USER";

export const requestUsers = () => ({
  type: REQUEST_USERS
});

export const receiveUsers = json => ({
  type: RECEIVE_USERS,
  users: Array.isArray(json.data) ? json.data : [json.data]
});

export const cancelEditUser = () => ({
  type: CANCEL_EDIT_USER
});

export const patchEditUser = patch => ({
  type: PATCH_EDIT_USER,
  patch
});

export function editUser(id) {
  return function(dispatch, getState) {
    const state = getState();
    const user = state.entities.users[id];
    return dispatch({
      type: EDIT_USER,
      id: user.id,
      active: user.status === "active",
      role: user.role
    });
  };
}

export function fetchUsers(params) {
  const paramsWithPath = Object.assign({}, params, { path: "/users" });
  return function(dispatch, getState) {
    dispatch(
      fetchResource(
        paramsWithPath,
        requestUsers,
        receiveUsers,
        setErrorNotification
      )
    );
  };
}

export function putUser(id, params) {
  const paramsWithPath = Object.assign({}, params, {
    method: "PUT",
    path: `/users/${id}`
  });
  return function(dispatch, getState) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        null,
        json => {
          dispatch(
            setSuccessNotification(`Updated user ${json.data.email}`, null)
          );
          return receiveUsers(json);
        },
        setErrorNotification
      )
    );
  };
}

export function saveUserBeingEdited() {
  return function(dispatch, getState) {
    const state = getState();
    const id = state.modalForm.editUser.id;
    const user = state.entities.users[id];
    if (!user) {
      return;
    }
    const patch = {
      role: state.modalForm.editUser.role,
      status: state.modalForm.editUser.active ? "active" : "inactive"
    };
    const params = { body: Object.assign({}, user, patch) };
    return dispatch(putUser(id, params));
  };
}



// WEBPACK FOOTER //
// ./src/actions/users.js